//
// Copyright (c) 2025 Emplifi, Inc.
//

export const COLLAPSIBLE_SECTION = "collapsibleSection";
export const COLLAPSIBLE_SECTION_CSS_CLASS = "knowledge-collapsible-section";
export const COLLAPSIBLE_SECTION_BODY = "collapsibleSectionBody";
export const COLLAPSIBLE_SECTION_BODY_CSS_CLASS = "knowledge-collapsible-section-body";
export const COLLAPSIBLE_SECTION_HEADER = "collapsibleSectionHeader";
export const COLLAPSIBLE_SECTION_HEADER_CSS_CLASS = "knowledge-collapsible-section-header";
